import * as types from './actionTypes';
// import { response } from './masterResponse';

const initalState = {
  masterData: null,
  kpiLoading: false,
  packageList: [],
  packageListLoading: false,
};

export const masterReducer = (state = initalState, action) => {
  const { type } = action;
  switch (type) {
    case types.SET_MASTER_DATA:
      return {
        ...state,
        masterData: {
          ...(state.masterData && typeof state.masterData === 'object' ? state.masterData : {}),
          ...(action.payload && typeof action.payload === 'object' ? action.payload : {}),
        },
      };

    case types.SET_KPI_LOADING:
      return {
        ...state,
        kpiLoading: action.payload,
      };

    case types.SET_PACKAGE_LIST_MASTER:
      return {
        ...state,
        packageList: action.payload,
      };

    case types.SET_PACKAGE_LIST_LOADING_MASTER:
      return {
        ...state,
        packageListLoading: action.payload,
      };

    default:
      return state;
  }
};
